import React from "react";
import { AppShape } from "@eave/shared/types/api";
import { borrowersAscending, getBorrowerEntityAsString } from "@eave/shared/utils/borrowers";
import BorrowerEditor from "./BorrowerEditor";
import { connect } from "react-redux";

const styles = require("./styles.module.scss");

interface Props {
  app: AppShape;
}

const BorrowersEditor = ({ app }: Props) => {
  const { borrowers } = app;

  return (
    <div className={styles.title}>
      <span>Borrowers</span>
      <div className={styles.container}>
        {borrowersAscending(borrowers).map(borrower => (
          <div key={`borrower${borrower.borrower_entity}`} className={styles.borrowerItem}>
            <span className={styles.borrowerTitle}>
              {`${getBorrowerEntityAsString(borrower.borrower_entity)}: `}
            </span>
            <BorrowerEditor appID={app.id} borrower={borrower} />
          </div>
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  app: ownProps.app ? ownProps.app : state.borrower.loanApplication,
});

export default connect<any, any, any>(mapStateToProps, null, null)(BorrowersEditor);
